// import React, { useState, useEffect } from "react";
// import "./Modals.css";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { useDispatch, useSelector } from "react-redux";
// import { Helmet } from "react-helmet";
// import AdsComponent from "../../AdsComponent/AdsComponent";

// const Modals = ({
//   show,
//   close,
//   institute,
//   StudyMaterial,
//   addval,
//   InstituteAdsVal,
//   StudyMaterialAdsVal,
//   comesFrom,
//   InstituteId,
//   timerData,
// }) => {
//   const study = useSelector((state) => state?.study);
//   const navigate = useNavigate();
//   const [timeleft, setTimeleft] = useState(parseInt(timerData?.timing));

//   const redirectedToParticularPage = () => {
//     let data = { institute: institute, InstituteId: InstituteId };
//     if (institute.length) {
//       if (comesFrom === "institute") {
//         // let splitData = institute.split(" ");
//         // let removeSpaceInInstitute = institute.replaceAll(" ", "-");
//         navigate(`/${data?.institute}/${InstituteId}`, { state: data });
//       } else
//         navigate(`/studymaterial/${study.module_name}`, { state: institute });
//     }
//   };

//   useEffect(() => {
//     if (timeleft === 0) {
//       setTimeleft(null);
//       close();
//       redirectedToParticularPage();
//     }

//     if (!timeleft) return;

//     const intervalId = setInterval(() => {
//       setTimeleft(timeleft - 1);
//     }, 1000);

//     return () => {
//       clearInterval(intervalId);
//     };
//   }, [timeleft]);

//   useEffect(() => {
//     if (
//       (InstituteAdsVal === "0" && comesFrom === "institute") ||
//       addval === "0"
//     ) {
//       return redirectedToParticularPage();
//     } else if (
//       (StudyMaterialAdsVal === "0" && comesFrom === "studyMaterial") ||
//       addval === "0"
//     ) {
//       return redirectedToParticularPage();
//     }
//   }, []);

//   const handleOverlayClick = (e) => {
//     e.stopPropagation();
//   };

//   return (
//     <>
//       {/* <Helmet>
//      <title></title>
//      </Helmet> */}

//       {StudyMaterialAdsVal === "1" && comesFrom === "studyMaterial"
//         ? show && (
//           <>
//             <div className="modalContainer"  >
//               <div
//                 className="modal_show"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 {/* <!-- ass --> */}

//                 <AdsComponent dataAdSlot="2597424317" />

//                 <footer className="modal_footer">
//                   <div className="model_button w-52 h-52">
//                     <button className="modal-close" onClick={() => close()}>
//                       Closeeee
//                     </button>
//                   </div>
//                   {timeleft != null && (
//                     <h3>00:{timeleft < 10 ? "0" + timeleft : timeleft}</h3>
//                   )}
//                 </footer>
//               </div>
//             </div>

//             <div className="modal_overlay" onClick={handleOverlayClick} />
//           </>
//         )
//         : InstituteAdsVal === "1" && comesFrom === "institute"
//           ? show && (
//             <>
//               <div className="modalContainer h-52 w-52">
//                 <div
//                   className="modal_show"
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <AdsComponent dataAdSlot="2597424317" />
//                   <footer className="modal_footer">
//                     <div className="model_button">
//                       <button className="modal-close" onClick={() => close()}>
//                         Close
//                       </button>
//                     </div>
//                     {timeleft != null && (
//                       <h3>00:{timeleft < 10 ? "0" + timeleft : timeleft}</h3>
//                     )}
//                   </footer>
//                 </div>
//               </div>
//               <div className="modal_overlay" onClick={handleOverlayClick} />
//             </>
//           )
//           : null}
//     </>
//   );
// };

// export default Modals;



import React, { useState, useEffect } from "react";
import "./Modals.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import AdsComponent from "../../AdsComponent/AdsComponent";

const Modals = ({
  show,
  close,
  institute,
  StudyMaterial,
  addval,
  InstituteAdsVal,
  StudyMaterialAdsVal,
  comesFrom,
  InstituteId, 
  timerData,
}) => {
  const study = useSelector((state) => state?.study);
  const navigate = useNavigate();
  const [timeleft, setTimeleft] = useState(parseInt(timerData?.timing));
  const [ads, setAds] = useState("1"); // default as 1

  const redirectedToParticularPage = () => {
    let data = { institute: institute, InstituteId: InstituteId };
    if (institute.length) {
      if (comesFrom === "institute") {
        navigate(`/${data?.institute}/${InstituteId}`, { state: data });
      } else {
        navigate(`/studymaterial/${study.module_name}`, { state: institute });
      }
    }
  };

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const res = await axios.get(
          "https://rollingnotes.in/app/backend/api_v2/ads_setting.php"
        );
        if (res.status === 200) {
          setAds(res.data?.ads || "0");
        }
      } catch (err) {
        console.error("Failed to fetch ads setting", err);
        setAds("0"); // fallback
      }
    };
    fetchAds();
  }, []);

  useEffect(() => {
    if (timeleft === 0) {
      setTimeleft(null);
      close();
      redirectedToParticularPage();
    }
    if (!timeleft) return;
    const intervalId = setInterval(() => {
      setTimeleft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeleft]);

  useEffect(() => {
    if (
      (InstituteAdsVal === "0" && comesFrom === "institute") ||
      (StudyMaterialAdsVal === "0" && comesFrom === "studyMaterial") ||
      addval === "0"
    ) {
      redirectedToParticularPage();
    }
  }, []);

  const handleOverlayClick = (e) => {
    e.stopPropagation();
  };

  const shouldShowAd =
    show &&
    ads === "1" &&
    ((StudyMaterialAdsVal === "1" && comesFrom === "studyMaterial") ||
      (InstituteAdsVal === "1" && comesFrom === "institute"));

  // Format timer display
  const formattedTime = timeleft != null ? 
    `00:${String(timeleft).padStart(2, "0")}` : 
    "00:00";

  return (
    <>
      {/* {shouldShowAd && (
        <>
          <div className="modal_overlay" onClick={handleOverlayClick}>
            <div className="modal_container" onClick={(e) => e.stopPropagation()}>
              <div className="modal_content">
                <div className="ad_container bg-gray">
                  <AdsComponent dataAdSlot="2597424317" />
                  <div className="ad_text">Ad</div>
                </div>
                <div className="modal_footer">
                  <button className="close_button" onClick={close}>
                    Close
                  </button>
                  {timeleft != null && (
                    <div className="timer">{formattedTime}</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          
        </>
      )} */}
      {shouldShowAd && (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }} onClick={handleOverlayClick}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.4)',
          width: '90%',
          maxWidth: '550px',
          padding: '20px'
        }} onClick={(e) => e.stopPropagation()}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '400px', // Increased from 300px to 400px
              border: '1px dashed #ccc',
              backgroundColor: 'white',
              marginBottom: '20px',
              position: 'relative'
            }}>
              <AdsComponent dataAdSlot="2597424317" />
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#666',
                fontSize: '24px',
                zIndex: 0
              }}>Ad</div>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: '10px'
            }}>
              <button
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#f5f5f5',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontWeight: 500
                }}
                onClick={() => {
                  close();
                  
                }}
              >
                Close
              </button>
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{formattedTime}</div>
            </div>
          </div>
        </div>
      </div>
    ) }
    </>
  );
};

export default Modals;




